<template>
  <content-loader
    class="v2-model-item-placeholder position-relative"
    primary-color="#ffffff"
    secondary-color="#cccccc"
    :primary-opacity="0.6"
    :secondary-opacity="0.5"
    :width="width"
    :height="totalHeight"
  >
    <rect x="0" y="0" :width="width" :height="thumbHeight" />
    <rect :x="width / 2 - nameWidth / 2" :y="thumbHeight - nameHeight / 2" rx="20" ry="20" :width="nameWidth" :height="nameHeight" />
    <rect :x="width / 2 - (width * 0.75) / 2" :y="thumbHeight + nameHeight / 2 + nameBottomGap" :width="width * 0.75" :height="locationHeight" />

    <rect
      v-for="dr in descriptionRows"
      :key="dr"
      :x="0"
      :y="thumbHeight + nameHeight / 2 + nameBottomGap + locationHeight + locationBottomGap + (dr - 1) * (descriptionGap + descriptionRowHeight)"
      :width="dr === descriptionRows ? width * 0.66 : width"
      :height="descriptionRowHeight"
    />
  </content-loader>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { ContentLoader } from "vue-content-loader";

defineOptions({
  name: "model-item-placeholder",
});

const containerWidth = ref(window.innerWidth > 1280 ? 1280 : window.innerWidth);
const gap = ref(window.innerWidth > 767 ? 36 : 16);
const innerGap = ref(window.innerWidth > 767 ? 12 : 8);
const nameWidth = ref(window.innerWidth > 767 ? 205 : 105);
const nameHeight = ref(window.innerWidth > 767 ? 40 : 28);
const nameBottomGap = ref(16);
const locationHeight = ref(21);
const locationBottomGap = ref(16);
const descriptionRows = ref(3);
const descriptionRowHeight = ref(18);
const descriptionGap = ref(6);
const descriptionBottomGap = ref(24);

const width = computed(() => {
  const containerClearWidth = containerWidth.value - gap.value * 2;
  return (containerWidth.value > 767 ? containerClearWidth / 4 : containerClearWidth / 2) - innerGap.value * 2;
});

const thumbHeight = computed(() => {
  return width.value / (7 / 10);
});

const totalHeight = computed(() => {
  return (
    thumbHeight.value +
    nameHeight.value / 2 +
    nameBottomGap.value +
    locationHeight.value +
    locationBottomGap.value +
    (descriptionRowHeight.value + descriptionGap.value) * descriptionRows.value +
    descriptionBottomGap.value
  );
});

const onResize = () => {
  containerWidth.value = window.innerWidth > 1280 ? 1280 : window.innerWidth;
};

onMounted(() => {
  window.addEventListener("resize", onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", onResize);
});
</script>
